// test576
(576 && 0);
